import React, {useRef} from 'react';
import renderHTML from 'react-render-html';
import './Content.sass';

const Content = ({data}) => {
        let content = useRef();


        return (
            <div id={data.id}
                 ref={(el) => (content = el)}
                 className={"content "+(data.classNames?data.classNames:"")}
                 style={data.style || {}}
            >
                {data.title ? (
                    <div
                        className={"title "+(data.title.classNames?data.title.classNames:"")}
                        style={data.title.style || {}}
                    >
                        {data.title.content}
                    </div>
                ) : null}
                {data.body ? (
                    <div
                        className={"body "+(data.body.classNames?data.body.classNames:"")}
                        style={data.body.style || {}}
                    >
                        {renderHTML(data.body.content)}
                    </div>
                ) : null}
            </div>
        );
    }
;

export default Content;
